import AppRoutes from "./Routes/AppRoutes"; 
import { ToastProvider } from '../src/Components/ToastProvider';
import IdleProvider from '../src/Components/IdleProvider';

function App() {   
  
  return (  
    <ToastProvider>
      <IdleProvider idleTimeout={3600000}>
        <AppRoutes/> 
      </IdleProvider>
    </ToastProvider>
  );
} 
export default App; 